export enum FunctionKind {
  Chairman = 'chairman',
  Secretary = 'secretary',
  Adjuster = 'adjuster',
}
